import React, {useEffect, useState} from 'react';
import './newsList.scss';
import InfoCard from "components/info-card/InfoCard";
import {InfoCardType} from 'models';
import {newsData} from 'data/newsData';
import {useParams, Outlet} from "react-router-dom";

const NewsList: React.FC = () => {
    let {newsId} = useParams();
    const [newsList, setNewsList] = useState<InfoCardType[]>(newsData);

    useEffect(() => {
        setNewsList(newsData);
    }, [])


    return (
        <>
            {newsId === undefined ?
                <div className={'news-list'}>
                    <div className={'news-list_wrapper max'}>
                        <h1>Top News & Articles</h1>
                        <div className={'news-list_wrapper_list'}>
                            {newsList.map(({id, date, heading, description, link, image}, index) => (
                                <InfoCard key={index.toString() + id} id={id} date={date} heading={heading}
                                          description={description} link={link}
                                          image={image}/>
                            ))}
                        </div>
                    </div>
                </div>
                :
                <Outlet/>
            }
        </>
    );
};

export default NewsList;

